import Vue from "vue";
import Component from "vue-class-component";
import ABaseComponent from 'Components/Base/ABaseComponent';
import { IPorter, PorterKey, UpdatePorterCommandArguments, GenericFieldDescription } from "Api/CoreApi";
import { Prop, Watch } from "vue-property-decorator";
import ApiProvider from "Api/ApiProvider";
import axios, { AxiosInstance } from 'axios';
//import UserInformationComponent from "Components/Base/UserInformationComponent";
import PorterBudgetStore from "Store/porterBudget/porterBudget";
@Component({
    template: "#customer-update-information-component-template"
})
export default class CustomerUpdateInformationComponent extends ABaseComponent {
    get porter() {
        return PorterBudgetStore.state.porter;
    }

    isDisabled: boolean = false;

    @Prop()
    defaultEmail: string;

    currentFirstName = "";
    currentLastName = "";
    currentStreet = "";
    currentCity = "";
    currentPhone = "";
    currentZip = "";

    @Watch("porter")
    setDefaultSettings() {
        if (!this.porter) return;

        this.currentFirstName = this.porter.firstName;
        this.currentLastName = this.porter.lastName;
        this.currentStreet = this.porter.street;
        this.currentCity = this.porter.city;
        this.currentPhone = this.porter.phone;
        this.currentZip = this.porter.zip;
    }

    async saveUpdatedSettings(e: any) {
        e.preventDefault();


        this.isDisabled = true;
        
        const client = ApiProvider.getApiClient();
        const fullPorterInformation = await client.getPorterById(this.porter.id);

        const args = new UpdatePorterCommandArguments({
            firstName: this.currentFirstName,
            lastName: this.currentLastName,
            functionCode: this.porter.functionCode,
            city: `${this.currentCity}`,
            street: this.currentStreet,
            phone: this.currentPhone,
            zip: this.currentZip,
            key: new PorterKey({
                id: fullPorterInformation.porter.id
            }),
            genericFields: fullPorterInformation.porter.genericFields,
        });

        args.genericFields["Email"] = this.defaultEmail;
        args.genericFields["Street"] = this.currentStreet;
        args.genericFields["Zip"] = this.currentZip;
        args.genericFields["City"] = this.currentCity;
        args.genericFields["Phone"] = this.currentPhone;

        // Update the porter table and NAV
        await client.updatePorter(args)
            .then(() => {
                const elements = e.target.elements;
                const formData = new FormData();
                formData.append("UserManagementForm", "1");
                formData.append("UserManagement_Form_Phone", elements.phone.value);
                // We update the DW user
                axios({
                    method: "post",
                    url: window.location.href,
                    data: formData,
                    headers: { "Content-Type": "multipart/form-data" },
                }).then(async response => {
                    await PorterBudgetStore.dispatchFetchPorter();
                    
                    //this.porter = await UserInformationComponent.getPorter();

                    //this.isDisabled = false;
                    alert("The porter has been saved.");
                    window.location.reload();

                }).catch(response => {
                    this.isDisabled = false;
                    alert("An error has occurred when updating the DW user,, please try again.");
                    window.location.reload();
                });
            }).catch(response => {
            this.isDisabled = false;
            alert("An error has occurred when updating to NAV, please try again.");
            window.location.reload();
        });

     



        //e.preventDefault();
        
        //const client = ApiProvider.getApiClient();
        //const fullPorterInformation = await client.getPorterById(this.porter.id);
        
        //const args = new UpdatePorterCommandArguments({
        //    firstName: this.currentFirstName,
        //    lastName: this.currentLastName,
        //    functionCode: this.porter.functionCode,
        //    city: `${this.currentCity}`,
        //    street: this.currentStreet,
            
        //    key: new PorterKey({
        //        id: fullPorterInformation.porter.id
        //    }),
        //    genericFields: fullPorterInformation.porter.genericFields,
        //});

        //await client.updatePorter(args);

        //await UserInformationComponent.refreshPorter(this.porter.id);
        //this.porter = await UserInformationComponent.getPorter();

        //this.isDisabled = false;
        //alert("The porter has been saved.");
        //window.location.reload();
    }

    async mounted() {
        this.setDefaultSettings();
    }

    async created() {
        await PorterBudgetStore.dispatchFetchPorter();
        //this.porter = await UserInformationComponent.getPorter();
    }
}

Vue.component('customer-update-information', CustomerUpdateInformationComponent);